<template>
  <v-expand-transition>
    <div v-if="active">
      <v-alert border="left" color="indigo darken-4" dark class="my-5 px-5 py-2" transition="scroll-x-transition">
        <v-row class="ma-0 pa-0" align="center">
          <v-col cols="11" class="ma-0 pa-0">{{ message }}</v-col>
          <v-col cols="1" class="ma-0 pa-0 text-right">
            <v-btn fab small color="indigo darken-3" dark depressed @click="clicked()">
              <v-icon x-small>mdi-minus</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-alert>
    </div>
  </v-expand-transition>
</template>

<script>
export default {
  name: 'TheDateAlert',
  props: {
    message: String,
    active: Boolean,
    click: Function,
  },
  methods: {
    clicked() {
      // alert(this.click)
      this.$emit('click')
    },
  },
}
</script>

<style></style>
